module.exports = __webpack_public_path__ + "static/media/reviseDark.faec2c48.svg";